export class DashboardCount {
    studentsCount: number = 0;
    teachersCount: number = 0;
    coursesCount: number = 0;
    sdrLeadsCount: number = 0;
    studentCourseCount: number = 0;
}
